import React, { useLayoutEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'

import { DataSourceProvider } from './providers/DataSourceProvider'
import LandingPage from './pages/LandingPage'
import TVPage from './pages/TVPage'
import ParticipantPage from './pages/ParticipantPage'
import PracticePage from './pages/PracticePage'
import AdminPage from './pages/AdminPage'
import PitchControlConceptsPage from './pages/PitchControlConceptsPage'

const DOCUMENT_THEME_CLASSES = [
  'landing-document',
  'participant-room-document',
  'tv-document'
]

const getDocumentTheme = (pathname) => {
  if (pathname === '/') {
    return { className: 'landing-document', color: '#4f4552' }
  }
  if (pathname.startsWith('/room/')) {
    return { className: 'participant-room-document', color: '#173543' }
  }
  if (pathname.startsWith('/tv/')) {
    return { className: 'tv-document', color: '#000000' }
  }
  return { className: '', color: '#f8fafc' }
}

function DocumentTheme() {
  const { pathname } = useLocation()

  useLayoutEffect(() => {
    const pageTheme = getDocumentTheme(pathname)
    const documentRoot = document.documentElement
    const themeColorMeta = document.querySelector('meta[name="theme-color"]')

    documentRoot.classList.remove(...DOCUMENT_THEME_CLASSES)
    if (pageTheme.className) {
      documentRoot.classList.add(pageTheme.className)
    }
    themeColorMeta?.setAttribute('content', pageTheme.color)
  }, [pathname])

  return null
}

function App() {
  return (
    <DataSourceProvider>
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <DocumentTheme />
      <div className="App" style={{ minHeight: '100%', overflowX: 'hidden' }}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/tv/:roomCode" element={<TVPage />} />
          <Route path="/room/:roomCode" element={<ParticipantPage />} />
          <Route path="/practice" element={<PracticePage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/pitch-lab" element={<PitchControlConceptsPage />} />
        </Routes>
        
        {/* Toast notifications */}
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: '#4ade80',
                secondary: '#fff',
              },
            },
            error: {
              duration: 5000,
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff',
              },
            },
          }}
        />
      </div>
    </Router>
    </DataSourceProvider>
  )
}

export default App
